import $ from "jquery"

class Hamburger {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Hamburger::initialize()")

		this._$burger = $(".bb-hamburger")

		// set listener for mobile show/hide subnavigation animation
		this._$burger.on("click hamburger.toggle", this._toggle.bind(this))
		this._$burger.on("hamburger.close", (event) => this._toggle(event, false))
		this._$burger.on("hamburger.open", (event) => this._toggle(event, true))
	}

	/**
	 * handle click on hamburger
	 * @return	{Void}
	 * @private
	 */
	_toggle(event = "", state) {
		event && event?.preventDefault()
		this._$burger.attr(
			"aria-expanded",
			state !== undefined ? state : !(this._$burger.attr("aria-expanded") === "true"),
		)
		this._$burger.attr(
			"aria-label",
			this._$burger.attr("aria-expanded") === "true"
				? this._$burger.attr("aria-label-close")
				: this._$burger.attr("aria-label-open"),
		)
	}
}

export default Hamburger
